import React from 'react';
import styled from 'styled-components';
import DatePicker from './datePicker';
import { CalendarProps } from './models';
import calenderIcon from '../../assets/calendar.svg';
import classNames from 'classnames';
import * as styles from './styles';

export const DatePickerV2 = styled(({ className, calenderArrows, disabled, ...props }: CalendarProps) => {
  const hasLabel = !!props.label;
  const defaultCalenderArrows = {
    prevArrow:
      '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M19.2625 9.2625L17.5 7.5L10 15L17.5 22.5L19.2625 20.7375L13.5375 15L19.2625 9.2625Z" fill="#002169"/>\n' +
      '</svg>',
    nextArrow:
      '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.5008 7.5L10.7383 9.2625L16.4633 15L10.7383 20.7375L12.5008 22.5L20.0008 15L12.5008 7.5Z" fill="#002169"/>\n' +
      '</svg>',
  };
  return (
    <div className={classNames(className, { disabled: disabled })}>
      <DatePicker {...props} disabled={disabled} calenderArrows={calenderArrows || defaultCalenderArrows} />
      <img className={classNames('calender-icon', { 'has-label': hasLabel })} src={calenderIcon} />
    </div>
  );
})`
  ${styles.DatePickerV2}
`;
